var map = {
	"./ClaudeSimple.js": [
		1940,
		940
	],
	"./Default.js": [
		1671,
		671
	],
	"./FakeNews.js": [
		3162,
		162
	],
	"./JailBreak0.js": [
		2838,
		457
	],
	"./JailBreak1.js": [
		7674,
		674
	],
	"./Jailbreak2.js": [
		7031,
		31
	],
	"./JailbreakMix.js": [
		435,
		435
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1430;
module.exports = webpackAsyncContext;